'use client';

import { useLegalTerms } from '@/providers/legalTerms';

const boolean = new Map();
boolean.set(true, 'true');
boolean.set(false, 'false');

const PrivacyPolicyHidden = () => {
  const { privacyPolicyAccepted } = useLegalTerms();

  const value = boolean.get(privacyPolicyAccepted);

  return (
    <input type="hidden" name="privacy-policy-accepted" value={value}></input>
  );
};

export default PrivacyPolicyHidden;
